<template>
  <div class="product-list">
    <Products
      :is-loading-button-on-detail="isLoading"
      :products="productList"
      :close-modal="closeModal"
      :is-builder="isBuilder"
      :came-from="cameFrom"
      @add-product="productId => addProduct(productId)"
      @remove-product="productId => removeProducts({ productIds: [productId] })"
    />
    <CheckoutBar
      title="Carteira"
      :summary-text="checkoutSummary"
      button-text="Próxima"
      :disable-input="productLenght === 0"
      @on-click-button="changeStep(EProductsAcquisitionSteps.REVIEW)"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, Ref } from 'vue';

import { Products } from '@/modules/catalog/views/Products';
import { CheckoutBar } from '@/modules/common/components/CheckoutBar';

import { EProductsAcquisitionSteps } from '@/modules/catalog/views/ProductsAcquisition/helpers';

import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';

const productList = inject('productList') as Ref<IProductGetLastState[]>;
const isLoading = inject('isLoading') as Ref<boolean>;
const closeModal = inject('closeModal') as Ref<boolean>;
const isBuilder = inject('isBuilder') as Ref<boolean>;
const cameFrom = inject('cameFrom') as Ref<string>;

const addProduct = inject('addProductToWallet', async (productId: string) => ({
  productId
}));
const removeProducts = inject(
  'removeProductFromWallet',
  async ({ productIds }: { productIds: string[] }) => ({
    productIds
  })
);
const changeStep = inject('changeStep', (step: EProductsAcquisitionSteps) => ({
  step
}));

const productLenght = computed(() => {
  return productList.value.length;
});

const checkoutSummary = computed(() => {
  return productLenght.value > 1
    ? `${productLenght.value} produtos selecionados`
    : productLenght.value === 1
    ? `${productLenght.value} produto selecionado`
    : `Nenhum produto selecionado`;
});
</script>

<style lang="less" scoped>
.product-list {
  padding-bottom: @size-spacing-x1400;
}
:deep(.footer__content) {
  max-width: 1008px;
  margin: 0 auto;
}
</style>
